import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { PostDto } from '../../../../api/interfaces/Posts';
import { useLoader } from '../../../../Loader/LoaderContext';
import { getService } from '../../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../../api';
import { getDisplayCompany, getDotColor,getStatusClass, getStatusDisplayName  } from '../../../../utility/RolesUtility';
const AVERAGE_READ_TIME_WPM = 200;
const ViewDetails: React.FC = () => {
  const [data, setData] = useState<PostDto>();
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    fetchVehicles();
  }, []);
  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let url: any;
        if(userInfo.roles === 'CHIEF_EDITOR'){
          url = API_ENDPOINTS.getEditCompanyCheif;
        }else if(userInfo.roles === 'JUNIOR_EDITOR'){
          url = API_ENDPOINTS.getEditCompanyJunior;
        }
      
      const response = await getService(url + "?id=" + userId);
      console.log(response);
      setData(response.data)
      
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    }
    finally {
      setTimeout(() => {
        setLoading(false)
      }, 500);
    }
  };
  const users = () => {
    navigate('/portals/contentCompanies/viewCompanies')
  }
  const usersScreen = () => {
    navigate(-1)
  }
  const addedName = () => {
    navigate(-1)
  }
  const handleEdit = (data: any) => {
    console.log('Edit clicked, data:', data);
    if (!data?.id) {
      console.error('Post ID is undefined');
      return;
    }
    navigate('/portals/contentCompanies/addCompany?companyId=' + data?.id);
  };
  const editProfile=(data:any) =>{
    navigate('/portals/contentCompanies/addCompany?companyId='+data?.appUserId)
 }
  return (
    <div className="h-full py-2 w-full">
      <div className="flex items-center cursor-pointer mb-4">
        <h2
          className="mr-2 text-gray-700 font-semibold text-sm"
          onClick={users}
        >
          {path === "/portals/contentCompanies/viewDetailsCompanies" && (
            <p>Companies</p>
          )}
        </h2>{" "}
        <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
        <span className="text-gray-400 font-semibold text-sm">
          {data?.name}
        </span>
      </div>
      <div className='bg-white p-4 rounded-[8px]'>
        <div className='flex justify-between items-center pb-4'>
          <div className='flex items-center'>
            <img src={data?.imageDto?.documentUrl ? data?.imageDto?.documentUrl :'/images/userImg.svg'} className='rounded-full w-[70px] h-[70px] mr-3' />
            <div>
              <div className='flex'>
                <h2 className='text-gray-900 font-bold text-[20px] mr-3'>{data?.name}</h2>
              </div>
              <p className='text-gray-600 text-base mt-1'>{data?.email || 'NA'}</p>
            </div>
          </div>
          <div onClick={()=>handleEdit(data)} className='flex items-center gap-2 cursor-pointer bg-white px-3 rounded-md border border-gray-300'> <img src='/images/editIcon.svg' />
          <a href="#" className="block py-2 text-sm text-[#374151] font-normal ">Edit Company</a>
        </div>
          
        </div>
        <p className='border border-gray-200'></p>
        <div className='px-4 py-5'>
          <div className='py-3'>
            <h2 className='text-gray-700 font-normal text-sm'>Company Name</h2>
            <p className='text-base font-semibold text-gray-900'>{data?.name}</p>
          </div>
          <div className='py-3'>
            <h2 className='text-gray-700 font-normal text-sm'>Company Type</h2>
            <p className='text-base font-semibold text-gray-900'>{getDisplayCompany(data?.type)}</p>
          </div>
          <div className='py-3'>
            <h2 className='text-gray-700 font-normal text-sm'>Email</h2>
            <p className='text-base font-semibold text-gray-900'>{data?.email || 'NA'}</p>
          </div>
          <div className='py-3'>
            <h2 className='text-gray-700 font-normal text-sm'>Contact Name</h2>
            <p className='text-base font-semibold text-gray-900'>{data?.contactName || 'NA'}</p>
          </div>
          <div className='py-3'>
            <h2 className='text-gray-700 font-normal text-sm'>Phone Number</h2>
            <p className='text-base font-semibold text-gray-900'>{data?.contactNo || 'NA'}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewDetails
